(function () {
    'use strict';

    angular
        .module('adm')
        .controller('AdmJobDescriptionEditController', AdmJobDescriptionEditController);

    AdmJobDescriptionEditController.$inject = ['$uibModalInstance', '$state', 'AdmService', 'jobDescription', 'admJobDescriptionList'];

    function AdmJobDescriptionEditController($uibModalInstance, $state, AdmService, jobDescription, admJobDescriptionList) {
        var vm = this;
        vm.activate                         = activate;
        vm.ok                               = ok;
        vm.cancel                           = cancel;
        vm.update                           = update;
        vm.jobDescription                   = {};
        vm.addResponsibilitiesField         = addResponsibilitiesField;
        vm.removeResponsibilitiesField      = removeResponsibilitiesField;
        vm.getJobDescriptionsForSelect      = getJobDescriptionsForSelect;
        vm.getDepartmentsForSelect          = getDepartmentsForSelect;
        vm.departmentSelected               = '';
        vm.positionSelected                 = '';
        vm.jobDescriptionsSelected          = [];
        vm.responsibilitiesFields           = [];
        vm.description                      = '';
        vm.admUserSelected                  = [];
        vm.getAdmUsersStaff                 = getAdmUsersStaff;

        angular.copy(jobDescription, vm.jobDescription);

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function update() {
            vm.query = {};
            vm.query['id']                  = vm.jobDescription.id;
            vm.query['department']          = vm.departmentSelected.id;
            vm.query['position']            = vm.positionSelected;
            vm.query['reportTo']            = vm.jobDescriptionsSelected;
            vm.query['responsibilities']    = vm.responsibilitiesFields;
            vm.query['adm_user_id']         = vm.admUserSelected;
            vm.query['description']         = vm.description;
            AdmService.updateJobDescription(vm.query).then(function(response){
                alertify.notify('Job Description is successfully updated', 'success', 3);
                admJobDescriptionList.activate();
                vm.cancel();
            }).catch(function(err) {
                alertify.notify('An error occurred on update this Job Description', 'error', 3);
            });
        }

        function getJobDescriptionsForSelect()
        {
            AdmService.getJobDescriptionsForSelect().then(function(response){
                vm.queryFlag        = true;
                vm.jobDescriptions  = response.data;
                vm.positions        = response.data;
            }).catch(function(err) {

            });
        }

        function getDepartmentsForSelect()
        {
            AdmService.getDepartmentsForSelect(vm.query).then(function(response){
                vm.queryFlag    = true;
                vm.departments  = response.data;
            }).catch(function(err) {

            });
        }

        function addResponsibilitiesField()
        {
            vm.responsibilitiesFields.push({value : ''});
        }

        function removeResponsibilitiesField(field)
        {
            vm.responsibilitiesFields.splice(vm.responsibilitiesFields.indexOf(field), 1);
        }

        function getAdmUsersStaff()
        {
            AdmService.getAdmUsersStaff(vm.query).then(function(response){
                vm.admUsers  = response.data;
            }).catch(function(err) {

            });
        }

        function activate() {
            vm.getDepartmentsForSelect();
            vm.getJobDescriptionsForSelect();
            vm.departmentSelected = {id : vm.jobDescription.department.id, name: vm.jobDescription.department.name};
            vm.positionSelected = vm.jobDescription.name;
            vm.description = vm.jobDescription.description;
            vm.getAdmUsersStaff();
            // if(vm.jobDescription.fpp_staff){
            //     vm.admUserSelected = {id : vm.jobDescription.fpp_staff.id, name : vm.jobDescription.fpp_staff.name };
            // }

            angular.forEach(vm.jobDescription.responsibilities, function(item) {
                vm.responsibilitiesFields.push({id: item.id, value : item.description});
            });
            angular.forEach(vm.jobDescription.report_to, function(item) {
                vm.jobDescriptionsSelected.push({id: item.job_description.id, name : item.job_description.name});
            });

            angular.forEach(vm.jobDescription.users, function(item) {
                vm.admUserSelected.push({id : item.user.id, name : item.user.name});
            });
        }

        vm.activate();

    }

})();